import { LocationQueryValue } from 'vue-router';

export const extractPage = (page?: LocationQueryValue | LocationQueryValue[]): number | null => {
	const parsedPage = Number(page);

	return parsedPage >= 1 ? parsedPage : null;
};
